/* tslint:disable */
/* eslint-disable */
export enum PaymentType {
  Web = 'WEB',
  Cod = 'COD',
  Cdod = 'CDOD'
}
